import { render } from "./ContextMenu.vue?vue&type=template&id=7f0771da&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=7f0771da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0771da"]])

export default __exports__